module.exports = __webpack_public_path__ + "img/Gruppenführer_I.c127eb2f.svg";